module.exports = {
  "name": "--pf-c-about-modal-box__hero--sm--BackgroundImage",
  "value": "url(assets/images/pfbg_992@2x.jpg)",
  "var": "var(--pf-c-about-modal-box__hero--sm--BackgroundImage)"
};